// Cadence-name to interval mapping for the pipeline DAG page (SIM-1140). This file used to hold the
// DAG's own staleness verdict, re-implemented here because apps cannot import from apps; the
// reasoning was sound and the conclusion wrong — SIM-2913 lifted the computation to
// `packages/core`. Do NOT reintroduce a local verdict: the deleted one judged freshness from
// BigQuery `lastModifiedTime`, which advances on any DML and cannot tell "the ingest ran" from "a
// cleanup overwrote the table", so the DAG and the config rows disagreed (SIM-2845).

const CADENCE_MAP: Record<string, number> = {
  hourly: 60,
  daily: 1440,
  weekly: 10080,
};

/**
 * Map a schedule key (e.g. "daily", "hourly") to its expected cadence in
 * minutes. Returns null for unknown keys — the caller treats null as "no
 * cadence expectation".
 */
export function scheduleToCadenceMinutes(schedule: string): number | null {
  return CADENCE_MAP[schedule.toLowerCase()] ?? null;
}
